<template>
  <question-base-wrapper
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed }"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      :rules="fieldValidationRules"
    >
      <checkbox-button
        v-for="(option, optionKey) in optionsList"
        :key="optionKey"
        v-model="questionData[optionKey]"
        :data-test="option"
        :error="failed"
        class="mb-4"
      >
        {{ option }}
      </checkbox-button>
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';

export default {
  name: 'question-multiselect',
  extends: QuestionBase,
  components: { QuestionBaseWrapper },
  data () {
    return {
      fields: this.customFields,
    };
  },
  computed: {
    optionsList () {
      return this.optionsConfig.options;
    },
    fieldValidationRules () {
      return this.validationRules?.field || 'required';
    },
  },
  methods: {
    getOptionText (option) {
      return option?.title || option;
    },
  },
};
</script>
